// src/layouts/MainLayout.js
import React from 'react';
import Header from '../components/Header';
import MobileNav from '../components/MobileNav';
import OfflineDetector from '../components/OfflineDetector';
import Footer from '../components/Footer';

const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <MobileNav />
      {/*<SubHeader />*/} {/* ✅ Only here */}
      {children}
      <Footer />
<OfflineDetector />
    </>
  );
};

export default MainLayout;